import script from "./Flussi.vue?vue&type=script&setup=true&lang=js"
export * from "./Flussi.vue?vue&type=script&setup=true&lang=js"

import "./Flussi.vue?vue&type=style&index=0&id=64235845&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64235845"]])

export default __exports__